import React from 'react';

interface StrategyReviewButtonProps {
  onClick: () => void;
  isLoading: boolean;
  disabled?: boolean;
}

const StrategyReviewButton: React.FC<StrategyReviewButtonProps> = ({ onClick, isLoading, disabled }) => {
  const isDisabled = isLoading || disabled;
  return (
    <button
      type="button"
      className="brief-btn"
      onClick={onClick}
      disabled={isDisabled}
      title="AI Strategy Review"
      style={disabled && !isLoading ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
    >
      {isLoading ? (
        <svg className="is-spin" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="10" opacity="0.3" />
          <path d="M12 2a10 10 0 0 1 10 10" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" aria-hidden="true" strokeLinejoin="round">
          <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
          <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
          <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
        </svg>
      )}
      <span>Strategy Review</span>
    </button>
  );
};

export default StrategyReviewButton;
